<template>
<div style="display: flex; flex-direction: column; height: 100vh;" id="mainFrame">
  <v-row v-if="loadingProgress == 100">
    <v-col>
       <h1>Prozesssteckbriefe</h1>
    </v-col>
    <v-col class="text-right" style="align-self: center">
      <v-btn id=OpenProcessMap outlined color="primary" elevation="0">
        <v-icon color="primary" large @click="openProcessMap()">mdi-map-legend</v-icon >
      </v-btn>
    </v-col>
  </v-row>
  <filter-component @applyTextFilter="applyTextFilter"/>
  <div style="flex: 1 1 auto; overflow-y: auto; height:100%;" >
    <v-data-table
            dense
            :headers="headersProcess"
            :items="filteredCharacteristics"
            sort-by="createdDate"
            :sort-desc="true"
        >
          <template v-slot:body="{items}">
            <tbody>
            <tr v-for="item in items"
                :key="item.id"
                @mouseover="selectItem(item)"
                @mouseleave="unSelectItem(item)">
              <td>
                <a class="date" color="gray_3" @click="previewCharacteristic(item)">{{ item.name }}</a>
              </td>
              <td>
                <span class="date" color="gray_3">{{ item.createdBy }}</span>
              </td>
              <td>
                <span class="date" color="gray_3">{{ new Date(item.createdDate).toLocaleString('de-DE', { day: 'numeric', month: 'short', year: 'numeric'}) }}</span>
              </td>
              <td>
                <div v-if="item === selectedItem" class="d-inline btn-group">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn color="gray" small text @click="deleteProcessCharacteristic(item)" v-bind="attrs" v-on="on"
                      class="btn-group__btn"><v-icon>delete</v-icon></v-btn>
                    </template>
                    <span>Löschen</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
            </tbody>
          </template>
        </v-data-table>
  </div>

<NewProcessCharacteristics ref="newCharacteristics" />
<add-custom-field-dialog />
  <ConfirmDialog ref="confirmDialog" />
<v-progress-linear
    style="position: absolute; bottom: 0;"
    color="primary accent-4"
    :indeterminate="loadingProgress == 100 ? false : true"
    height="5"
    :value="loadingProgress"
  ></v-progress-linear>
</div>
</template>

<script>
import DataTable from '../../components/common/DataTable.vue';
import AddCustomFieldDialog from './AddCustomFieldDialog.vue';
import NewProcessCharacteristics from './ProcessCharacteristicsDialog.vue';
import processMapService from '@/components/processMapService.js';
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
import FilterComponent from '../../components/FilterComponent.vue';
export default {
  components: { 
  DataTable, 
  NewProcessCharacteristics,
  AddCustomFieldDialog,
  ConfirmDialog,
    FilterComponent},
  name: "ProcessMap",
  data() {
    return {
      characteristics: [],
      processMaps: [],
      noEditor: "No current editor",
      loadingProgress: 0,
      tab: null,
      selectedItem: null,
      headersProcess: [
/*       { text: 'Prozesstyp', value: 'type' }, */
          {
            text: 'Prozessname',
            align: 'start',
            value: 'fileName',
          },
          { text: 'Ersteller', value: 'initiator' },
          { text: 'Erstellt am', value: 'creationDate'},
          { text: 'Aktionen', value: 'actions',},
      ],
      headerMap: [
          {
            text: 'Name der Prozesslandkarte',
            align: 'start',
            value: 'name',
          },
          { text: 'Ersteller', value: 'createdBy' },
          { text: 'Erstellt am', value: 'creationDate'},
          { text: 'Enthaltene Prozesse', value: 'processCount' },
          { text: 'Aktionen', value: 'actions'}
      ],
      search: '',
      showCreateDialog: false,
      showImportDialog: false,
      loadingProgress: 100,
      viewSurveys: false,
      selectedItem: null,
      filteredCharacteristics: []
    };
  },
  computed:{
    userId(){
      return this.$store.state.user.username;
    },
    tableItems(){
      return this.processMaps;
    }
  },
  mounted() {
    this.retrieveProcessMaps();
    // Set Table Header Max-Width
    let ths = document.querySelectorAll('th>span');
    for (let elem of ths) {
      if (elem.innerHTML.length > 18) {
        elem.parentElement.setAttribute("style", "display:flex;");
        elem.setAttribute("style", "display:flex;max-width:4rem;justify-content:center;align-items:center;");
      }
    }
  },
  methods: {
    openMapDialog(){
      this.$refs.newCharacteristics.open().then(res =>{
        processMapService.addProcessCharacteristic(res).then(res => {
          this.retrieveProcessMaps();
        })
      })
    },
    retrieveProcessMaps() {
      this.loadingProgress = 100;
      this.processes = [];
      processMapService.retrieveProcessCharacteristics(false, this.characteristics).then(res => {
        this.characteristics = res.data;
        this.filteredCharacteristics = this.characteristics;
      })
    },
    selectItem(item) {
      this.selectedItem = item;
    },
    unSelectItem(item) {
      this.selectedItem = false;
    },
    previewCharacteristic(item){
      this.$refs.newCharacteristics.open(item, true).then(res =>{})
    },
    openProcessMap(){
      this.$router.push({name: 'processMap'});
    },
    deleteProcessCharacteristic(item){
      this.$refs.confirmDialog
      .open(
        "Prozesssteckbrief löschen",
        "Möchten Sie den Steckbrief: "+item.name+" wirklich löschen?"
      )
      .then(async () => {
        processMapService.deleteCharacteristic(item.id).then(() => this.retrieveProcessMaps());
      })
      .catch(e => console.log(e))

    },
    applyTextFilter(filterItems){
      this.filteredCharacteristics = this.characteristics.filter(charac => charac.name.toUpperCase().includes(filterItems.textFilter.toUpperCase()));
    }
  }
};
</script>
<style scoped>
.white{
  color: var(--v-primary-base) !important;
}
.v-tab--active{
  color:initial;
}
.v-tab--active > .v-chip{
  background-color: var(--v-primary-base) !important;
  color: #F5F5F5 !important;
}
#tab{
  max-width:unset;
}
#tab.active{
  font-size: 10rem;
}
#chip{
  margin-left: 10px;
}
#datatable{
  position: inherit !important;
}
</style>